var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.75C19.7353 12.75 21.75 10.7353 21.75 8.25C21.75 5.76472 19.7353 3.75 17.25 3.75C14.7647 3.75 12.75 5.76472 12.75 8.25C12.75 10.7353 14.7647 12.75 17.25 12.75Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7181 6.76272L17.0234 9.45738C16.7344 9.74637 16.2659 9.74636 15.9769 9.45736L14.7793 8.2597",
    stroke: "current",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25C7.91421 8.25 8.25 7.91421 8.25 7.5C8.25 7.08579 7.91421 6.75 7.5 6.75C7.08579 6.75 6.75 7.08579 6.75 7.5C6.75 7.91421 7.08579 8.25 7.5 8.25Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.25C7.95 17.25 8.25 17.55 8.25 18C8.25 18.45 7.95 18.75 7.5 18.75C7.05 18.75 6.75 18.45 6.75 18C6.75 17.55 7.05 17.25 7.5 17.25ZM7.5 15.75C6.225 15.75 5.25 16.725 5.25 18C5.25 19.275 6.225 20.25 7.5 20.25C8.775 20.25 9.75 19.275 9.75 18C9.75 16.725 8.775 15.75 7.5 15.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.25C18.45 17.25 18.75 17.55 18.75 18C18.75 18.45 18.45 18.75 18 18.75C17.55 18.75 17.25 18.45 17.25 18C17.25 17.55 17.55 17.25 18 17.25ZM18 15.75C16.725 15.75 15.75 16.725 15.75 18C15.75 19.275 16.725 20.25 18 20.25C19.275 20.25 20.25 19.275 20.25 18C20.25 16.725 19.275 15.75 18 15.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H15",
    stroke: "current",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.5H12.75",
    stroke: "current",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.25C3.225 5.25 4.65 6.45 5.025 8.1L6.75 16.5H16.35C17.775 16.5 18.975 15.525 19.275 14.175L20.0284 11.625",
    stroke: "current",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder24);
export default __webpack_public_path__ + "static/media/Order-24.f0bd50e4.svg";
export { ForwardRef as ReactComponent };